module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAIaGhgCZ/xVrmwhqnxZkmh1cjQxflghfkxJPgw5PgxdMfwpPhQZPgwJPgyJDbzM8YjUkAD0YDCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAACH5BAEAABwALAAAAAAgACAAAAWdICeOZGmeaGpu7Ka+JiDPcD3fQK3iuH7yPB9pM9tQgDkhq3i5IH2tWxS4E02lSypKdsVlsr1tlzdOnspkMMB13lSQ6dsWTqf96vU5Hq7nQvYXLChENxgbEnUtgxw4hhsTcIqLjFgbETwOFIIpbDgPLZc3FpuclGkbTlxLMIRAFhqtYDB7XEKmeba3T7kidLwkdna/I2aMwyuSx8okIQA7"


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadSW_S7.gif
// module id = ASt5
// module chunks = 48